module.exports = __webpack_public_path__ + "static/media/client-cardcurator.a979b4d1.svg";